<template>
    <vSelect>
        <template #open-indicator>
            <Loader v-if="isLoading" width="20px" height="20px" />
            <Chevron v-else v-bind="attributes" />
        </template>
        <template #no-options>
            {{ useTranslate("tiw__vselect__notFound") }}
        </template>
    </vSelect>
</template>

<script lang="ts">
export default {
    name: "SelectComponent",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Select]
 * Select / обертка
 */

import { ref } from "vue";
// Components
import vSelect from "vue-select";

// Icons
import Chevron from "@/ui/icons/chevron.vue";
// Hooks
import useTranslate from "~/tiw/hooks/useTranslate/useTranslate";

import Loader from "../icons/loader.vue";

const { isLoading } = defineProps<{ isLoading?: boolean }>();

// ⓘ См. https://vue-select.org/api/slots.html#open-indicator
const attributes = ref({
    ref: "openIndicator",
    role: "presentation",
    class: "vs__open-indicator",
});
</script>
